import LoginPage from './login/LoginPage.vue';
import RegistrationPage from './registration/RegistrationPage.vue';
import WelcomePage from './welcome/WelcomePage.vue';
// import WelcomePage from './welcome/WelcomePage.vue';

const routes = [
  {
    path: '/welcome',
    name: 'welcome',
    component: WelcomePage,
    meta: {
      title: 'Bienvenue - 1BPay',
      requiresAuth: false
    }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    meta: {
      title: 'Connexion - 1BPay',
      requiresAuth: false
    }
  },
  {
    path: '/register',
    name: 'register',
    component: RegistrationPage,
    meta: {
      title: 'Inscription - 1BPay',
      requiresAuth: false
    }
  }
];

export default routes;
